export default "__VITE_ASSET__1be6106b__"